import { GET_USER_GRANTED_ACCESS } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_USER_GRANTED_ACCESS_URL } from '../../constants/apiUrls';
import { AccessOption } from '../../models';

interface GetUserAccessResponse {
  VIEW?: AccessOption[];
  CREATE?: AccessOption[];
  EDIT?: AccessOption[];
  DELETE?: AccessOption[];
}

export const useGetUserGrantedAccess = ({ functionName }: { functionName: string }) => {
  const getUserAuthorities = async () => {
    const res = await axiosClient.get<GetUserAccessResponse>(
      GET_USER_GRANTED_ACCESS_URL(functionName)
    );
    return res.data;
  };

  return useCustomQuery(GET_USER_GRANTED_ACCESS, getUserAuthorities, {
    staleTime: Infinity,
  });
};
